<template>
    <section>
        <VCard>
            <VCardText class="d-flex flex-wrap gap-4">
                <VSpacer />

                <div class="d-flex align-center flex-wrap gap-4">
                    <!-- 👉 Search  -->
                    <AppTextField v-model="searchQuery" :placeholder="t('admin_notifications.search_customers')"
                        density="compact" prepend-inner-icon="tabler-search" style="inline-size: 20rem;" clearable />
                    <!-- 👉 Add customer button -->
                    <VBtn v-if="$can('create', 'customer')" color="success" prepend-icon="tabler-plus"
                        @click="openCustomerModal()">
                        {{ $t('admin_notifications.add_new_customer') }}
                    </VBtn>
                </div>
            </VCardText>

            <VDivider />

            <!-- SECTION datatable -->
            <VDataTableServer v-model:items-per-page="itemsPerPage" v-model:page="page" :items-per-page-options="[
                { value: 10, title: '10' },
                { value: 20, title: '20' },
                { value: 50, title: '50' },
                { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' },
            ]" :items="customers" :items-length="totalCustomers" :headers="headers" class="styled-table"
                @update:options="updateOptions">
                <!-- Actions -->
                <template #item.actions="{ item }">
                    <div class="d-flex gap-2">
                        <VTooltip>
                            <template #activator="{ props }">
                                <IconBtn v-bind="props" v-if="$can('edit', 'customer')"
                                    @click="openCustomerModal(item)">
                                    <VIcon icon="tabler-edit" />
                                </IconBtn>
                            </template>
                            <span>{{ $t('admin_notifications.edit_customer') }}</span>
                        </VTooltip>

                        <!-- <VTooltip>
                            <template #activator="{ props }">
                                <IconBtn v-bind="props" v-if="$can('edit', 'customer')"
                                    :color="item.is_active ? 'warning' : 'success'" @click="toggleStatus(item)">
                                    <VIcon :icon="item.is_active ? 'tabler-user-off' : 'tabler-user-check'" />
                                </IconBtn>
                            </template>
                            <span>{{ item.is_active ? $t('admin_notifications.deactivate_customer') :
                                $t('admin_notifications.activate_customer') }}</span>
                        </VTooltip>

                        <VTooltip>
                            <template #activator="{ props }">
                                <IconBtn v-bind="props" v-if="$can('edit', 'customer')"
                                    :color="item.crm_access_active ? 'warning' : 'info'" @click="toggleCrmAccess(item)">
                                    <VIcon :icon="item.crm_access_active ? 'tabler-lock-off' : 'tabler-lock'" />
                                </IconBtn>
                            </template>
                            <span>{{ item.crm_access_active ? $t('admin_notifications.disable_crm_access') :
                                $t('admin_notifications.enable_crm_access') }}</span>
                        </VTooltip> -->

                        <!-- <VTooltip>
                            <template #activator="{ props }">
                                <IconBtn v-bind="props" v-if="$can('delete', 'customer')" color="error" @click="deleteCustomer(item)">
                                    <VIcon icon="tabler-trash" />
                                </IconBtn>
                            </template>
                            <span>{{ $t('admin_notifications.delete_customer') }}</span>
                        </VTooltip> -->
                    </div>
                </template>


                <template #bottom>
                    <VCardText class="pt-2">
                        <div class="d-flex flex-wrap justify-center justify-sm-space-between gap-y-2 mt-2">
                            <VSelect v-model="itemsPerPage" :items="[10, 25, 50, 100]" label="Rows per page:"
                                variant="underlined" style="max-inline-size: 8rem;min-inline-size: 5rem;" />

                            <VPagination v-model="page" :total-visible="$vuetify.display.smAndDown ? 3 : 5"
                                :length="Math.ceil(totalCustomers / itemsPerPage)" />
                        </div>
                    </VCardText>
                </template>
            </VDataTableServer>
        </VCard>

        <!-- Customer Modal -->
        <VDialog v-model="isCustomerModalVisible" max-width="1200px" scrollable>
            <VCard>
                <VCardTitle class="d-flex justify-space-between align-center">
                    {{ selectedCustomer ? t('admin_notifications.edit_customer') :
                        t('admin_notifications.add_new_customer') }}
                    <VBtn icon variant="text" @click="closeCustomerModal">
                        <VIcon icon="tabler-x" />
                    </VBtn>
                </VCardTitle>

                <VCardText>

                    <!-- Tabs for Customer Form and Telegram Settings -->
                    <VTabs v-model="activeTab" class="mb-4">
                        <VTab value="general">
                            <VIcon icon="tabler-user" class="me-2" />
                            {{ t('admin_notifications.general_info') }}
                        </VTab>
                        <VTab v-if="selectedCustomer" value="telegram">
                            <VIcon icon="tabler-brand-telegram" class="me-2" />
                            {{ t('customer.telegram.title') }}
                        </VTab>
                    </VTabs>

                    <VWindow class="pa-1" v-model="activeTab">
                        <!-- General Information Tab -->
                        <VWindowItem value="general">
                            <VForm ref="formRef" @submit.prevent="onSubmit">
                                <VRow>
                                    <!-- Left Column -->
                                    <VCol cols="6">
                                        <VTextField v-model="form.title"
                                            :label="t('admin_notifications.customer_company_name')"
                                            :rules="form.crm_access_active ? [v => !!v || t('admin_notifications.name_required')] : []"
                                            :error-messages="errors.title" :required="form.crm_access_active" />
                                    </VCol>

                                    <VCol cols="6">
                                        <VTextField v-model="form.phone"
                                            :label="t('admin_notifications.customer_phone')"
                                            :error-messages="errors.phone" />
                                    </VCol>

                                    <VCol cols="6">
                                        <VTextField v-model="form.contact_person"
                                            :label="t('admin_notifications.contact_person')"
                                            :error-messages="errors.contact_person" />
                                    </VCol>

                                    <VCol cols="6">
                                        <VTextField v-model="form.email"
                                            :label="t('admin_notifications.customer_email')" type="email"
                                            :error-messages="errors.email" :required="form.crm_access_active" />
                                    </VCol>

                                    <VCol cols="6">
                                        <VTextarea v-model="form.address"
                                            :label="t('admin_notifications.customer_address')" rows="3"
                                            :error-messages="errors.address" />
                                    </VCol>

                                    <VCol cols="6">
                                        <VSelect v-model="form.role_id" :label="t('admin_notifications.customer_role')"
                                            :items="customerRoles" item-title="name" item-value="id"
                                            :error-messages="errors.role_id" clearable />
                                    </VCol>

                                    <VCol cols="6">
                                        <VTextField v-model="form.password"
                                            :label="t('admin_notifications.customer_password')"
                                            :type="showPassword ? 'text' : 'password'" :error-messages="errors.password"
                                            :required="form.crm_access_active">
                                            <template #append-inner>
                                                <IconBtn @click="showPassword = !showPassword">
                                                    <VIcon :icon="showPassword ? 'tabler-eye-off' : 'tabler-eye'" />
                                                </IconBtn>
                                            </template>
                                        </VTextField>
                                    </VCol>

                                    <VCol cols="6">
                                        <VTextField v-model="form.confirm_password"
                                            :label="t('admin_notifications.confirm_password')"
                                            :type="showConfirmPassword ? 'text' : 'password'"
                                            :error-messages="errors.confirm_password"
                                            :required="form.crm_access_active">
                                            <template #append-inner>
                                                <IconBtn @click="showConfirmPassword = !showConfirmPassword">
                                                    <VIcon
                                                        :icon="showConfirmPassword ? 'tabler-eye-off' : 'tabler-eye'" />
                                                </IconBtn>
                                            </template>
                                        </VTextField>
                                    </VCol>

                                    <VCol cols="6">
                                        <VSelect v-model="form.access_level"
                                            :label="t('admin_notifications.select_order_access')"
                                            :items="accessLevelOptions" item-title="label" item-value="value"
                                            :error-messages="errors.access_level" required />
                                    </VCol>

                                    <!-- Toggle Switches -->
                                    <VCol cols="12">
                                        <div class="d-flex gap-6">
                                            <VSwitch v-model="form.crm_access_active"
                                                :label="t('admin_notifications.allow_crm_access')" color="success"
                                                hide-details />
                                            <VSwitch v-model="form.is_active"
                                                :label="t('admin_notifications.deactivate_customer')"
                                                :color="form.is_active ? 'error' : 'success'" :true-value="false"
                                                :false-value="true" hide-details />
                                        </div>
                                    </VCol>
                                </VRow>
                            </VForm>
                        </VWindowItem>

                        <!-- Telegram Settings Tab -->
                        <VWindowItem v-if="selectedCustomer" value="telegram">
                            <CustomerTelegramSettings :customer="selectedCustomer"
                                @update:customer="handleCustomerUpdate" />
                        </VWindowItem>
                    </VWindow>
                </VCardText>

                <VCardActions class="pa-4 d-flex gap-4 justify-end">
                    <VBtn style="width: 150px;" variant="flat" @click="onSubmit" :loading="isSubmitting">
                        {{ $t('admin_notifications.submit') }}
                    </VBtn>
                    <VBtn color="secondary" variant="tonal" style="width: 150px;" @click="closeCustomerModal">
                        {{ $t('admin_notifications.cancel') }}
                    </VBtn>
                </VCardActions>
            </VCard>
        </VDialog>
    </section>
</template>

<script setup>
definePage({
    meta: {
        action: 'view',
        subject: 'customer',
    },
})

import { VDataTableServer } from 'vuetify/labs/VDataTable'
import $api from "~/utils/api";
import { onMounted, ref, watch, computed } from "vue";
import { useI18n } from 'vue-i18n';
import { useHead } from '@unhead/vue'
import CustomerTelegramSettings from '~/components/CustomerTelegramSettings.vue'

const { t } = useI18n()

// Set page title
useHead({
    title: t('menu.clients'),
    meta: [
        { name: 'description', content: t('admin_notifications.clients_description') }
    ]
})

// Data table options
const itemsPerPage = ref(10)
const page = ref(1)
const sortBy = ref()
const orderBy = ref()

// Search and filters
const searchQuery = ref('')
const debouncedSearchQuery = ref('')
const statusFilter = ref('')
const crmAccessFilter = ref('')

let searchTimeout = null

const debounceSearch = (value) => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
        debouncedSearchQuery.value = value
    }, 500)
}

const updateOptions = options => {
    page.value = options.page
    sortBy.value = options.sortBy[0]?.key
    orderBy.value = options.sortBy[0]?.order
}
const accessLevelOptions = computed(() => [
    { value: 'view_only', label: t('admin_notifications.view_only') },
    // { value: 'edit', label: t('admin_notifications.edit_access') },
])

// Headers
const headers = computed(() => [
    {
        title: 'ID',
        key: 'id',
        sortable: false,
        width: '80px',
    },
    {
        title: t('admin_notifications.customer_name'),
        key: 'title',
        sortable: false,
    },
    {
        title: t('admin_notifications.phone'),
        key: 'phone',
        sortable: false,
    },
    {
        title: t('admin_notifications.contact'),
        key: 'contact_person',
        sortable: false,
    },
    {
        title: t('admin_notifications.email'),
        key: 'email',
        sortable: false,
    },
    {
        title: t('admin_notifications.address'),
        key: 'address',
        sortable: false,
    },
    {
        title: t('admin_notifications.actions'),
        key: 'actions',
        sortable: false,
        width: '75px',
    },
])

const {
    data: customersData,
    execute: fetchCustomers,
} = await useApi(createUrl('/api/pjob-customers', {
    query: {
        q: debouncedSearchQuery,
        status: statusFilter,
        crm_access: crmAccessFilter,
        per_page: itemsPerPage,
        page,
        sortBy,
        orderBy,
    },
}))

const customers = computed(() => customersData.value?.data || [])
const totalCustomers = computed(() => customersData.value?.meta?.total || 0)

// Customer roles
const customerRoles = ref([])

// Modal state
const isCustomerModalVisible = ref(false)
const selectedCustomer = ref(null)
const isSubmitting = ref(false)
const formRef = ref()
const errors = ref({})
const activeTab = ref('general')

// Form data
const form = ref({
    title: '',
    contact_person: '',
    address: '',
    phone: '',
    email: '',
    role_id: null,
    password: '',
    confirm_password: '',
    access_level: 'view_only',
    crm_access_active: false,
    is_active: true,
})

// Password visibility toggles
const showPassword = ref(false)
const showConfirmPassword = ref(false)

// Watch for filter changes
watch([debouncedSearchQuery, statusFilter, crmAccessFilter, itemsPerPage], () => {
    page.value = 1
    fetchCustomers()
})

// Watch for search query changes to apply debounce
watch(searchQuery, (newValue) => {
    debounceSearch(newValue)
})

// Load customer roles
const loadCustomerRoles = async () => {
    try {
        const { data } = await $api.get('/roles')
        customerRoles.value = data.data
    } catch (error) {
        console.error('Ошибка загрузки ролей:', error)
    }
}

// Handle customer update from Telegram settings
const handleCustomerUpdate = (updatedCustomer) => {
    selectedCustomer.value = updatedCustomer
    // Also update in the list if needed
    const index = customers.value.findIndex(c => c.id === updatedCustomer.id)
    if (index !== -1) {
        customers.value[index] = updatedCustomer
    }
}

// Modal methods
const openCustomerModal = (customer = null) => {
    selectedCustomer.value = customer
    activeTab.value = 'general'

    // Reset password visibility toggles
    showPassword.value = false
    showConfirmPassword.value = false

    if (customer) {
        form.value = {
            title: customer.title,
            contact_person: customer.contact_person,
            address: customer.address,
            phone: customer.phone,
            email: customer.email,
            role_id: customer.role_id,
            password: '',
            confirm_password: '',
            access_level: customer.access_level || 'view_only',
            crm_access_active: customer.crm_access_active || false,
            is_active: customer.is_active !== false,
        }
    } else {
        form.value = {
            title: '',
            contact_person: '',
            address: '',
            phone: '',
            email: '',
            role_id: null,
            password: '',
            confirm_password: '',
            access_level: 'view_only',
            crm_access_active: false,
            is_active: true,
        }
    }
    isCustomerModalVisible.value = true
}

const closeCustomerModal = () => {
    isCustomerModalVisible.value = false
    selectedCustomer.value = null
    activeTab.value = 'general'
    form.value = {
        title: '',
        contact_person: '',
        address: '',
        phone: '',
        email: '',
        role_id: null,
        password: '',
        confirm_password: '',
        access_level: 'view_only',
        crm_access_active: true,
        is_active: true,
    }
    errors.value = {}
}

const onSubmit = async () => {
    const { valid } = await formRef.value.validate()
    if (!valid) return

    isSubmitting.value = true
    errors.value = {}

    try {
        if (selectedCustomer.value) {
            // Update
            await $api.post(`/pjob-customers/${selectedCustomer.value.id}`, form.value)
        } else {
            // Create
            await $api.post('/pjob-customers', form.value)
        }

        closeCustomerModal()
        await fetchCustomers()
    } catch (error) {
        console.error('Ошибка при сохранении клиента:', error)

        if (error.response?.data?.errors) {
            errors.value = error.response.data.errors
        } else if (error.response?.data?.message) {
            errors.value = { general: error.response.data.message }
        } else {
            errors.value = { general: 'Произошла неизвестная ошибка' }
        }
    } finally {
        isSubmitting.value = false
    }
}


// Delete customer
const deleteCustomer = async (customer) => {
    if (!confirm(t('admin_notifications.confirm_delete_customer', { name: customer.title }))) return

    try {
        await $api.delete(`/pjob-customers/${customer.id}`)
        await fetchCustomers()
    } catch (error) {
        console.error('Ошибка при удалении клиента:', error)
    }
}

// Load data on mount
onMounted(() => {
    fetchCustomers()
    loadCustomerRoles()
})
</script>

<style scoped>
.styled-table :deep(.v-data-table__th) {
    font-weight: bold !important;
    position: relative;
}

.styled-table :deep(.v-data-table__th:not(:last-child))::after {
    content: '';
    position: absolute;
    right: 0;
    top: 30%;
    bottom: 30%;
    width: 2px;
    background-color: rgba(var(--v-theme-on-surface), 0.12);
}

.styled-table :deep(.v-data-table-header__content) {
    font-weight: bold !important;
}
</style>
